export default __webpack_public_path__ + "static/1closetshelfbench-25beb745573399b4476b28a3196f0d0b.png";